module.exports = __webpack_public_path__ + "img/thank_you.598245c4.png";